import React, { Component } from "react";

export default class step1 extends Component {
  render() {
    return (
      <div className="step-container">
        <div className="subtitle">Step One</div>
        <div className="step-name">
          Step 1 <br /> and send your request
        </div>
      </div>
    );
  }
}
